import React from 'react';
import { format } from 'date-fns';

export const getStatusIcon = (status) => {
  switch (status) {
    case 'draft':
      return 'clock-yellow';
    case 'pending_for_algorithm':
    case 'processing_algorithm':
      return 'clock-blue-spin';
    case 'set_algo_preferences':
    case 'validated':
    case 'completed':
    case 'sessions_scheduled':
      return 'check-green';
    case 'failed':
      return 'x-red';
    case 'cancelled':
      return 'x-gray';
    default:
      return 'exclamation-gray';
  }
};

export const getStatusColor = (status) => {
  switch (status) {
    case 'draft':
      return 'bg-yellow-100 text-yellow-800';
    case 'validated':
      return 'bg-green-100 text-green-800';
    case 'set_algo_preferences':
      return 'bg-blue-100 text-blue-800';
    case 'pending_for_algorithm':
    case 'processing_algorithm':
      return 'bg-blue-100 text-blue-800';
    case 'completed':
      return 'bg-green-100 text-green-800';
    case 'sessions_scheduled':
      return 'bg-green-100 text-green-800';
    case 'failed':
      return 'bg-red-100 text-red-800';
    case 'cancelled':
      return 'bg-gray-100 text-gray-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

export const getStatusDisplayName = (status) => {
  switch (status) {
    case 'draft':
      return 'Draft';
    case 'validated':
      return 'Validated';
    case 'set_algo_preferences':
      return 'Set Algorithm Preferences';
    case 'pending_for_algorithm':
      return 'Pending Algorithm';
    case 'processing_algorithm':
      return 'Processing Algorithm';
    case 'completed':
      return 'Completed';
    case 'sessions_scheduled':
      return 'Sessions Scheduled';
    case 'failed':
      return 'Failed';
    case 'cancelled':
      return 'Cancelled';
    default:
      return status;
  }
};

export const formatDateRange = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  return `${format(start, 'MMM dd')} - ${format(end, 'MMM dd, yyyy')}`;
};
